import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { selectTextToImagesError } from '../vb/reducer'
import { selectIsResultCleared } from './reducer'
import { setIsNotificationVisible } from './actions'
import { UNABLE_TO_CREATE_AN_IMAGE_WITH_THIS_PROMPT_PLEASE_TRY_ANOTHER_PROMPT } from './translation/resources'
import alertIcon from './assets/alert-icon.png'
import './ErrorMessage.css'

const ErrorMessage = () => {
  const { t } = useTranslation()
  const errorMessage = useSelector(selectTextToImagesError)
  const isResultCleared = useSelector(selectIsResultCleared)
  const showErrorMessage = !isResultCleared && errorMessage
  const dispatch = useDispatch()

  useEffect(() => {
    if (showErrorMessage) {
      dispatch(setIsNotificationVisible(false))
    }
  }, [showErrorMessage, dispatch])

  if (!showErrorMessage) {
    return null
  }

  return (
    <div className="ErrorMessage" role="alert">
      <>
        <img className="ErrorMessage__icon" src={alertIcon} alt="alert" />
        {errorMessage === 'content moderation' ? (
          <p className="ErrorMessage__text">
            {t(
              UNABLE_TO_CREATE_AN_IMAGE_WITH_THIS_PROMPT_PLEASE_TRY_ANOTHER_PROMPT
            )}
          </p>
        ) : (
          <p className="ErrorMessage__text">{t(errorMessage)}</p>
        )}
      </>
    </div>
  )
}

export default ErrorMessage
